/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Hero_Rating_ShortInputs */

const en_why_listening_hero_rating_short = /** @type {(inputs: Why_Listening_Hero_Rating_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`on the App Store and Google Play`)
};

const es_why_listening_hero_rating_short = /** @type {(inputs: Why_Listening_Hero_Rating_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en App Store y Google Play`)
};

/**
* | output |
* | --- |
* | "on the App Store and Google Play" |
*
* @param {Why_Listening_Hero_Rating_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_hero_rating_short = /** @type {((inputs?: Why_Listening_Hero_Rating_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Hero_Rating_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_hero_rating_short(inputs)
	return en_why_listening_hero_rating_short(inputs)
});